import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { db } from '../../firebase';
import { collection, getDocs } from 'firebase/firestore';
import { useAuth } from '../../context/AuthContext';
import Layout from '../../components/ui/Layout';
import { IconBuilding, IconPlus } from '@tabler/icons-react';

function SettingsNav({ active }) {
  const navigate = useNavigate();
  const items = [
    { label: 'Branches', path: '/settings/branches' },
    { label: 'Departments', path: '/settings/departments' },
    { label: 'Roles', path: '/settings/roles' },
    { label: 'Templates', path: '/settings/templates' },
    { label: 'Notifications', path: '/settings/notifications' },
    { label: 'Organisation', path: '/settings/organisation' },
    { label: 'Audit log', path: '/settings/audit' },
  ];
  return (
    <div style={{ width: 200, borderRight: '0.5px solid var(--color-border-light)', padding: '24px 14px', flexShrink: 0 }}>
      <div style={{ fontSize: 11, fontWeight: 400, color: 'var(--color-text-tertiary)', letterSpacing: '0.05em', marginBottom: 10, padding: '0 8px' }}>GROUP SETTINGS</div>
      {items.map(item => (
        <div
          key={item.path}
          onClick={() => navigate(item.path)}
          style={{ padding: '9px 10px', borderRadius: 'var(--radius-md)', fontSize: 13, color: active === item.label ? 'var(--color-brand)' : 'var(--color-text-secondary)', background: active === item.label ? 'var(--color-brand-light)' : 'transparent', cursor: 'pointer', marginBottom: 2 }}
        >
          {item.label}
        </div>
      ))}
    </div>
  );
}

export { SettingsNav };

export default function Branches() {
  const { orgId, userProfile } = useAuth();
  const [branches, setBranches] = useState([]);
  const [loading, setLoading] = useState(true);

  const resolvedOrgId = orgId || userProfile?.orgId;

  useEffect(() => {
    const load = async () => {
      if (!resolvedOrgId) {
        setLoading(false);
        return;
      }
      try {
        const snap = await getDocs(collection(db, 'organisations', resolvedOrgId, 'branches'));
        setBranches(snap.docs.map(d => ({ id: d.id, ...d.data() })));
      } catch (err) {
        console.error(err);
      }
      setLoading(false);
    };
    load();
  }, [resolvedOrgId]);

  return (
    <Layout>
      <div style={{ display: 'flex', flex: 1, minHeight: '100vh' }}>
        <SettingsNav active="Branches" />
        <div style={{ flex: 1, padding: 'var(--main-padding)' }}>
          <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: 24 }}>
            <div>
              <h1 style={{ fontSize: 22, fontWeight: 400, marginBottom: 4 }}>Branches</h1>
              <p style={{ fontSize: 13, color: 'var(--color-text-tertiary)' }}>
                {loading ? 'Loading...' : `${branches.length} branch${branches.length !== 1 ? 'es' : ''}`}
              </p>
            </div>
            <button style={{ background: 'var(--color-brand)', color: '#fff', border: 'none', borderRadius: 'var(--radius-md)', padding: '8px 16px', fontSize: 13, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 6 }}>
              <IconPlus size={15} stroke={1.5} /> Add branch
            </button>
          </div>

          {loading ? (
            <div style={{ fontSize: 13, color: 'var(--color-text-tertiary)', padding: '32px 0', textAlign: 'center' }}>Loading branches...</div>
          ) : branches.length === 0 ? (
            <div style={{ background: 'var(--color-bg-primary)', border: '0.5px solid var(--color-border-light)', borderRadius: 'var(--radius-lg)', padding: '48px 32px', textAlign: 'center' }}>
              <IconBuilding size={32} color="var(--color-text-tertiary)" stroke={1.5} style={{ marginBottom: 12 }} />
              <div style={{ fontSize: 14, fontWeight: 400, color: 'var(--color-text-primary)', marginBottom: 6 }}>No branches yet</div>
              <div style={{ fontSize: 13, color: 'var(--color-text-tertiary)' }}>Add your first branch to get started</div>
            </div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              {branches.map(branch => (
                <div key={branch.id} style={{ background: 'var(--color-bg-primary)', border: '0.5px solid var(--color-border-light)', borderRadius: 'var(--radius-lg)', padding: '16px 20px', display: 'flex', alignItems: 'center', gap: 14 }}>
                  <div style={{ width: 36, height: 36, borderRadius: 'var(--radius-md)', background: 'var(--color-brand-light)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                    <IconBuilding size={18} color="var(--color-brand)" stroke={1.5} />
                  </div>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: 14, fontWeight: 400, color: 'var(--color-text-primary)', marginBottom: 4 }}>{branch.name}</div>
                    {branch.address && (
                      <div style={{ fontSize: 12, color: 'var(--color-text-tertiary)', marginBottom: branch.departments?.length ? 6 : 0 }}>{branch.address}</div>
                    )}
                    {branch.departments?.length > 0 && (
                      <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                        {branch.departments.map(d => (
                          <span key={d} style={{ fontSize: 11, padding: '2px 8px', borderRadius: 20, background: 'var(--color-bg-secondary)', color: 'var(--color-text-secondary)', border: '0.5px solid var(--color-border-light)' }}>{d}</span>
                        ))}
                      </div>
                    )}
                  </div>
                  <button style={{ background: 'transparent', color: 'var(--color-text-secondary)', border: '0.5px solid var(--color-border-medium)', borderRadius: 'var(--radius-md)', padding: '6px 14px', fontSize: 12, cursor: 'pointer' }}>Edit</button>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </Layout>
  );
}